import { Link } from "react-router-dom";
import { SITE } from "@/data/site";
import { services, getServicePath } from "@/data/services";
import { homeSectionTo } from "@/utils/navigation";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[#55d0ff]/15 bg-[#030812]"
    >
      <div className="tw-container py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-4">
            <img
              src={SITE.logo}
              alt="TOP WASH DOO — profesionalna B2B perionica Beograd"
              className="h-20 sm:h-24 md:h-28 w-auto drop-shadow-[0_4px_24px_rgba(31,168,255,0.55)]"
            />
            <p className="mt-6 max-w-sm text-[#a7bcd6] text-sm leading-relaxed">
              TOP WASH DOO je profesionalna B2B perionica u Beogradu, specijalizovana
              za pranje posteljine, stolnjaka, peškira i uniformi za restorane,
              hotele, kafiće, pansione i spa centre.
            </p>
          </div>

          <div className="sm:col-span-1 lg:col-span-2">
            <div className="overline">Podaci firme</div>
            <ul className="mt-4 space-y-2 text-sm text-[#c8d6ec]">
              <li className="font-heading-md text-white">{SITE.name}</li>
              <li>{SITE.address.street}</li>
              <li>{SITE.address.postalCode} {SITE.address.city}</li>
              <li>{SITE.address.country}</li>
              <li className="pt-2 text-[#8ea6c8]">
                PIB: <span className="text-white font-semibold">{SITE.pib}</span>
              </li>
              <li className="text-[#8ea6c8]">
                MB: <span className="text-white font-semibold">{SITE.mb}</span>
              </li>
            </ul>
          </div>

          <div className="sm:col-span-1 lg:col-span-3">
            <div className="overline">Usluge</div>
            <ul className="mt-4 space-y-2 text-sm">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link to={getServicePath(s.slug)} className="tw-link">
                    {s.shortTitle}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="sm:col-span-2 lg:col-span-3">
            <div className="overline">Kontakt</div>
            <ul className="mt-4 space-y-2 text-sm text-[#c8d6ec]">
              <li>
                <a href={SITE.phoneHref} className="tw-link">{SITE.phone}</a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} className="tw-link">{SITE.email}</a>
              </li>
              <li className="text-[#8ea6c8] pt-2">{SITE.hours}</li>
            </ul>
            <ul className="mt-6 space-y-2 text-sm">
              <li><Link to={homeSectionTo("#how-it-works")} className="tw-link">Kako radimo</Link></li>
              <li><Link to={homeSectionTo("#contact")} className="tw-link">Kontakt</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#55d0ff]/12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-[#8ea6c8]">
            © {new Date().getFullYear()} {SITE.name}. Sva prava zadržana.
          </p>
          <p className="text-xs text-[#8ea6c8]">
            Fotografije: Unsplash
          </p>
        </div>
      </div>
    </footer>
  );
}
